import { ApolloClient, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
    //uri: "https://graphql.quable.io/graphql", //TODO Env variable
    //relative duo to proxy in package.json
    uri: "/graphql",
    cache: new InMemoryCache(),
});

export default client;
